import { api } from '../../services/api';

export interface KeyValuePair {
    key: string;
    value: string;
}

export interface CustomApiAuth {
    enabled: boolean;
    auth_url?: string | null;
    method: 'GET' | 'POST';
    request_body?: any;
    token_path?: string | null;
    header_key?: string | null;
}

export interface CustomApiData {
    _id?: string;
    name_custom: string;
    api_url: string;
    api_type: 'weather' | 'prayer' | 'forex' | 'general';
    token?: string | null;
    method: 'GET' | 'POST';
    refresh_interval?: number;
    headers?: KeyValuePair[];
    request_body?: any;
    filtering?: KeyValuePair[];
    customapidata?: any;
    auth?: CustomApiAuth;
    last_refreshed_at?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface PreviewCustomApiRequest {
    api_url: string;
    token?: string | null;
    method: 'GET' | 'POST';
    headers?: KeyValuePair[];
    request_body?: any;
    auth?: CustomApiAuth;
}

export interface CustomApiListResponse {
    success: boolean;
    data: CustomApiData[];
}

export interface CustomApiResponse {
    success: boolean;
    data: CustomApiData;
}

export const customApiApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getCustomApis: builder.query<CustomApiListResponse, void>({
            query: () => ({
                url: '/editor/custom-api',
                method: 'GET',
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ _id }) => ({ type: 'CustomApi' as const, id: _id })),
                        { type: 'CustomApi', id: 'LIST' },
                    ]
                    : [{ type: 'CustomApi', id: 'LIST' }],
        }),
        createCustomApi: builder.mutation<CustomApiResponse, Partial<CustomApiData>>({
            query: (data) => ({
                url: '/editor/custom-api',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [{ type: 'CustomApi', id: 'LIST' }],
        }),
        previewCustomApi: builder.mutation<{ success: boolean; data: any }, PreviewCustomApiRequest>({
            query: (data) => ({
                url: '/editor/custom-api/preview',
                method: 'POST',
                body: data,
            }),
        }),
        updateCustomApi: builder.mutation<CustomApiResponse, { id: string; data: Partial<CustomApiData> }>({
            query: ({ id, data }) => ({
                url: `/editor/custom-api/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (_result, _error, { id }) => [
                { type: 'CustomApi', id },
                { type: 'CustomApi', id: 'LIST' },
            ],
        }),
        deleteCustomApi: builder.mutation<{ success: boolean; message: string }, string>({
            query: (id) => ({
                url: `/editor/custom-api/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'CustomApi', id: 'LIST' }],
        }),
        runCustomApi: builder.query<{ success: boolean; data: any }, string>({
            query: (id) => ({
                url: `/editor/custom-api/run/${id}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetCustomApisQuery,
    useCreateCustomApiMutation,
    usePreviewCustomApiMutation,
    useUpdateCustomApiMutation,
    useDeleteCustomApiMutation,
    useRunCustomApiQuery,
    useLazyRunCustomApiQuery,
} = customApiApi;
